function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-23d9a7d0\",\"scoped\":true,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector?type=styles&index=0!./book.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./book.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-23d9a7d0\",\"hasScoped\":true}!../../../vue-loader/lib/selector?type=template&index=0!./book.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-23d9a7d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-book-component/components/book/book.vue
// module id = 24
// module chunks = 0